import request from '@/utils/request'

const goodsServiceApi = {
  list: '/goods/service',
  create: '/goods/service',
  update: id => `/goods/service/${id}`,
  detail: id => `/goods/service/${id}`,
  remove: id => `/goods/service/${id}`,
  switchStatus: id => `/goods/service/status/${id}`
}

export function list(parameter) {
  return request({
    url: goodsServiceApi.list,
    method: 'get',
    params: parameter
  })
}

export function create(parameter) {
  return request({
    url: goodsServiceApi.create,
    method: 'post',
    data: parameter
  })
}

export function update(parameter) {
  const { goodsId } = parameter
  delete parameter.goodsId
  return request({
    url: goodsServiceApi.update(goodsId),
    method: 'put',
    data: parameter
  })
}

export function detail(parameter) {
  return request({
    url: goodsServiceApi.detail(parameter),
    method: 'get'
  })
}

export function remove(parameter) {
  return request({
    url: goodsServiceApi.remove(parameter),
    method: 'delete'
  })
}

export function switchStatus(parameter) {
  return request({
    url: goodsServiceApi.switchStatus(parameter),
    method: 'get'
  })
}
